export default `Digital Millennium Copyright Act Takedown Notice

Select Exposure and its operator, Select Exposure LLC, respects the intellectual property of others and adheres to the provisions set forth in the Digital Millennium Copyright Act, as embodied in 17 U.S.C. §512 (“DMCA”) by responding to notices of alleged infringement that comply with the DMCA and other applicable laws.

If you believe that your work has been copied in a way that constitutes copyright infringement, please submit a report in writing and provide us with the following information:

•	A physical signature of the person authorized to act on behalf of the owner of the copyright interest;

•	A description of the copyrighted work that you claim has been infringed upon;

•	A description of where the material that you claim is infringing is located on the site;

•	Your address, telephone number, and e-mail address;

•	A statement by you that you have a good-faith belief that the disputed use is not authorized by the copyright owner, its agent, or the law; and

•	A statement by you, made under penalty of perjury, that the above information in your notice is accurate and that you are the copyright owner or authorized to act on the copyright owner's behalf.

Please note that this procedure is exclusively for notifying us that your copyrighted material has been infringed. If you choose to submit a copyright takedown request, please remember that you are initiating a legal process. Misrepresenting facts in a DMCA notice, can result in legal liability for damages, court costs and attorneys fees under 17 U.S.C. §512(f). These notice and takedown procedures only apply to claims of copyright infringement by copyright holders and their agents. Please ensure that you meet all of the legal qualifications before submitting a DMCA Notice to our Designated Agent.

Written notice of any claim of copyright infringement related to this website or any content delivered in connection with our services should be provided to the following Designated Agent:

Pursuant to 17 U.S.C. 512(c). Select Exposure designated Copyright Agent is:

Jonathan Bailey
CopyByte
3157 Gentilly Blvd Suite # 2254
New Orleans, LA 70122
Phone: 1-504-356-4555
Email: selectexposure-dmca@copybyte.com`;
